import React from "react";
import { Link } from "react-scroll";
import { withTranslation } from "react-i18next";
import logoImage from "../assets/image/logo.png";

const Header = (props) => {
  
  // constructor(props) {
  //   super(props);
  //   state = {
  //     language: [],
  //     languagesData: {},
  //   };
  // }
//  useEffect(()=>{
//   let ham = document.body.classList;
//   ham.toggle("menu-active");
//  },[props])
  // componentDidMount(){
  //     const languageOptions={
  //         languagesData: {}
  //     }
  //     props.setLanguage(languageOptions);

  //     axios
  //     .get(`https://staging.firsthive.com/FCC/api/applanguagesList`, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .then(response => {
  //         if(response.status === 200){
  //             setState({language: response.data.data})
  //         }
  //     })
  //     .catch((err) => {
  //         if(err && err.response && err.response.status === 404 || err && err.response && err.response.status === 400){
  //             console.log(err)
  //         }
  //     });

  //     axios.get(
  //         `https://staging.firsthive.com/FCC/api/applanguageData?language="English"`,
  //         {
  //             headers: {
  //             'Content-Type': 'application/json',
  //             'Authorization': localStorage.getItem('x-access-token')
  //             }
  //         }
  //         )
  //         .then((res) => {
  //             if(res.status === 200){
  //                 setState({languageData: res.data.data})
  //                 const languageOptions={
  //                     languagesData: res.data.data
  //                 }

  //                 setState({
  //                     ...languageOptions
  //                 })
  //                 props.setLanguage(languageOptions);
  //             }
  //         })
  //         .catch((err) => {
  //             if(err && err.response && err.response.status === 404 || err && err.response && err.response.status === 400){
  //                 console.log(err);
  //             }
  //         });
  // }

  const menuToggle = () => {
    let ham = document.body.classList;
    ham.toggle("menu-active");
  }

  const menuToggleOnLink = () =>  {
    // if(window.outerWidth <= 770) {
  
      // props.handleViewAllSite(false)
    let ham = document.body.classList;
    ham.toggle("menu-active");
    // }
  }

  const handleLanguage = (e) => {
    props.i18n.changeLanguage(e.target.value);

    // Using api get languages
    // axios.get(
    //     `https://staging.firsthive.com/FCC/api/applanguageData?language=${e.target.value ? e.target.value : "English"}`,
    //     {
    //         headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': localStorage.getItem('x-access-token')
    //         }
    //     }
    //     )
    //     .then((res) => {
    //         if(res.status === 200){
    //             setState({languageData: res.data.data})
    //             const languageOptions={
    //                 languagesData: res.data.data
    //             }

    //             setState({
    //                 ...languageOptions
    //             })
    //             props.setLanguage(languageOptions);
    //         }
    //     })
    //     .catch((err) => {
    //         if(err && err.response && err.response.status === 404 || err && err.response && err.response.status === 400){
    //             console.log(err);
    //         }
    //     });
  };

  // render() {
    // const path = window.location.pathname;
    // const pathParams = path.split('/');
    const { certificates, achievements, siteDetails, fccMoments, t,isViewAllSite } =
      props;
      // console.log("props",props)
    // const { language } = state;
    return (
      <header className="main-header">
        <div className="container">
          <a href="javascript:void(0);" className="site-logo">
            {/* <a href={`/profile/${pathParams[2]}`} className="site-logo"> */}
            <img src={logoImage} alt="Logo" />
          </a>

          <div className="header-right">
            <div className="select-language-group">
              <label htmlFor="SelectLanguage">{t("Select Language")}</label>
              <select
                id="SelectLanguage"
                className="select_language"
                onChange={(e) => handleLanguage(e)}
              >
                <option value="en">English</option>
                <option value="hn">Hindi</option>
                {/* {language.map((l,i) => {
                                    return(
                                    <option value={l} key={i}>{l}</option>
                                    )
                                })} */}
              </select>
            </div>
            <ul className="site-menu">
              {siteDetails && siteDetails.length > 0 && (
                <li className="site-menu-item">
                  <Link
                    activeClass="active"
                    to="mySites"
                    spy={true}
                    smooth={true}
                    offset={-104}
                    duration={500}
                    className="site-menu-link"
                    onClick={menuToggleOnLink}
                  >
                    {t("My Sites")}
                  </Link>
                </li>
              )}
              {certificates && certificates.length > 0 && (
                <li className="site-menu-item">
                  <Link
                    activeClass="active"
                    to="myCertifications"
                    spy={true}
                    smooth={true}
                    offset={isViewAllSite ? -330 :-90}
                    duration={500}
                    className="site-menu-link"
                    onClick={menuToggleOnLink}
                  >
                    {t("My Certifications")}
                  </Link>
                </li>
              )}
              {achievements && achievements.length > 0 && (
                <li className="site-menu-item">
                  <Link
                    activeClass="active"
                    to="myAchievements"
                    spy={true}
                    smooth={true}
                    offset={isViewAllSite ? -330 :-90}
                    duration={500}
                    className="site-menu-link"
                    onClick={menuToggleOnLink}
                  >
                    {t("My Achievements")}
                  </Link>
                </li>
              )}
              {fccMoments && fccMoments.length > 0 && (
                <li className="site-menu-item">
                  <Link
                    activeClass="active"
                    to="myFccMoments"
                    spy={true}
                    smooth={true}
                    // offset={-104}
                    offset={isViewAllSite ? -330 :-90}
                    duration={500}
                    className="site-menu-link"
                    onClick={menuToggleOnLink}
                  >
                    {t("My FCC Moments")}
                  </Link>
                </li>
              )}
            </ul>

            <span
              onClick={menuToggle}
              role="button"
              className="site-menu-button"
            >
              <span className="fa fa-bars open" />
              <span className="fa fa-close  close" />
            </span>
          </div>
        </div>
      </header>
    );
  // }
}

export default withTranslation()(Header);
